import React from 'react'
import useAxios from '@use-hooks/axios'
import uuid from 'react-uuid'
import { ProductType, ServerProductType } from '../types'

export interface ProductsContext {
  products: ProductType[]
  productsError?: Error
  productsLoading: boolean
}

export const ProductsContext = React.createContext<ProductsContext>(null)

export const ProductsProvider: React.FC = ({ children }) => {
  const { error, loading, response } = useAxios<string>({
    url: `/wp-content/themes/v1/js/app/cache/sofas.json`,
    method: 'GET',
    trigger: 'true',
  })

  let products: ProductType[] = []
  if (response && response.data) {
    const json: ServerProductType[] = JSON.parse(response.data)
    products = json.map(product => {
      const colours = Object.keys(product.colours).reduce((obj, key) => {
        obj[key] = {
          ...product.colours[key],
          uuid: uuid(),
        }

        return obj
      }, {})

      return {
        ...product,
        colours,
      }
    })
  }

  return (
    <ProductsContext.Provider
      value={{
        products,
        productsError: error,
        productsLoading: loading,
      }}
    >
      {children}
    </ProductsContext.Provider>
  )
}

export const useProducts = (): ProductsContext =>
  React.useContext(ProductsContext)
